import { ArrowDropDown as ArrowDropDownIcon } from "@mui/icons-material";
import { Button, Menu, MenuItem, Stack } from "@mui/material";
import { useState } from "react";

const getDateRanges = () => {
  const ranges = [
    { label: "All Time", value: "ALL_TIME" },
    { label: "Last 7 Days", value: "LAST_7_DAYS" },
    { label: "Last 30 Days", value: "LAST_30_DAYS" },
    { label: "Last 90 Days", value: "LAST_90_DAYS" },
    { label: "Month to Date", value: "MTD" },
    { label: "Year to Date", value: "YTD" },
    { label: "Last Quarter", value: "LAST_QUARTER" },
    { label: "Calendar Month", value: "CALENDAR_MONTH" },
    { label: "Custom Range", value: "CUSTOM_RANGE" },
  ];

  return ranges;
};

const DateRangeSelector = ({ selectedRange, setSelectedRange }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const dateRanges = getDateRanges();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRangeSelect = (range) => {
    setSelectedRange(range);
    handleClose();
  };

  const getSelectedLabel = () => {
    const range = dateRanges.find((r) => r.value === selectedRange);
    return range ? range.label : "Select Date Range";
  };

  return (
    <Stack direction={"row"} spacing={2} alignItems={"center"}>
      <Button
        variant={"outlined"}
        color={"secondary"}
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
        sx={{
          minWidth: 200,
          justifyContent: "space-between",
          textTransform: "none",
          color: "gray",
        }}
      >
        {getSelectedLabel()}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "date-range-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {dateRanges.map((range) => (
          <MenuItem
            key={range.value}
            onClick={() => handleRangeSelect(range.value)}
            selected={selectedRange === range.value}
          >
            {range.label}
          </MenuItem>
        ))}
      </Menu>
    </Stack>
  );
};

export default DateRangeSelector;
